import React from 'react';
import lionImg from '../assets/email-lion.png';

const LionIcon = ({ sx = {}, style = {}, size, ...props }) => {
    // Extract size from sx.fontSize or size prop or default 
    const fontSize = sx.fontSize || size || 24;
    const imgSize = typeof fontSize === 'number' ? fontSize : parseInt(fontSize) || 24;

    // Extract filter from sx if present
    const { fontSize: _fs, filter, ...restSx } = sx;

    return (
        <img
            src={lionImg}
            alt="Email Lion"
            width={imgSize}
            height={imgSize}
            style={{
                objectFit: 'contain',
                display: 'inline-block',
                verticalAlign: 'middle',
                ...(filter ? { filter } : {}),
                ...style,
            }}
            {...props}
        />
    );
};

export default LionIcon;
